import { Component, inject, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '@packages/ng-shared-services';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('dialogElement') dialogElement!: ElementRef<HTMLDialogElement>;

  public toastService = inject(ToastService);

  ngAfterViewInit(): void {
    // Open dialog to place it in browser's top layer (above modals)
    // Use show() not showModal() to avoid backdrop
    const dialog = this.dialogElement.nativeElement;
    if (!dialog.open) {
      dialog.show();
    }
  }

  ngOnDestroy(): void {
    // Clean up: close dialog
    const dialog = this.dialogElement?.nativeElement;
    if (dialog?.open) {
      dialog.close();
    }
  }

  getToastType(classname: string): string {
    if (classname?.includes('success')) return 'success';
    if (classname?.includes('danger') || classname?.includes('error')) return 'error';
    if (classname?.includes('warning')) return 'warning';
    return 'info';
  }
}
